import { delay } from '@/utils';

export default {
  namespaced: true,
  actions: {
    async CREATE({ commit, dispatch }, {
      message,
      color,
      dismissable = true,
      timeout = 2000,
    }) {
      const options = {
        active: true,
        message,
        color,
        dismissable,
      };
      commit('UPDATE_TOAST', options);
      await delay(timeout);
      dispatch('DISMISS');
    },
    DISMISS({ commit }) {
      commit('UPDATE_TOAST', { active: false });
    },
  },
  mutations: {
    UPDATE_TOAST(state, options) {
      state.options = { ...state.options, ...options };
    },
  },
  state() {
    return {
      options: {
        active: false,
        message: null,
        color: 'success',
        dismissable: false,
      },
    };
  },
};
